import DefaultLayout from "@/layouts/DefaultLayout";
import KChangePasswordForm from "@/components/Auth/KPassword/KChangePasswordForm";
import { VImg } from "vuetify/lib";

export default {
	name: "CreatePasswordPage",

	metaInfo: { title: "Create Password" },

	render() {
		return <DefaultLayout maxWidth="320px">
			<VImg
				class="mb-3 mx-auto d-block"
				maxWidth={233}
				src={require( "@/assets/logos/logo.png" )}
			></VImg>

			<KChangePasswordForm
				action="auth/password/create"
				formTitle="Set Account Password"
			></KChangePasswordForm>
		</DefaultLayout>;
	}
};
